<!-- eslint-disable @angular-eslint/template/interactive-supports-focus -->
<!-- eslint-disable @angular-eslint/template/click-events-have-key-events -->
@let functional = allowOpenChange();
<div
  class="container"
  [class.functional]="functional"
  (click)="changeView(CalendarView.CALENDAR)"
>
  <div class="labels">
    <div
      class="label-button"
      [class.active]="view() === CalendarView.MONTHS"
      [class.disabled]="view() === CalendarView.YEARS"
      (click)="changeView(CalendarView.MONTHS); $event.stopPropagation()"
    >
      <p class="f-body-m f-semibold">
        {{ date() | date: 'LLLL' | titlecase }}
      </p>

      @if (functional) {
        <onyx-icon name="arrow-alt-down-outlined" [size]="16"></onyx-icon>
      }
    </div>

    <div
      class="label-button"
      [class.active]="view() === CalendarView.YEARS"
      [class.disabled]="view() === CalendarView.MONTHS"
      (click)="changeView(CalendarView.YEARS); $event.stopPropagation()"
    >
      <p class="f-body-m f-semibold">{{ date() | date: 'y' }}</p>

      @if (functional) {
        <onyx-icon name="arrow-alt-down-outlined" [size]="16"></onyx-icon>
      }
    </div>
  </div>

  @if (functional) {
    <div class="buttons">
      <onyx-icon-button
        variant="transparent"
        color="black"
        [size]="24"
        (click)="monthChange.emit(-1)"
      >
        <onyx-icon
          class="left"
          name="arrow-alt-left-outlined"
          [size]="16"
        ></onyx-icon>
      </onyx-icon-button>

      <onyx-icon-button
        variant="transparent"
        color="black"
        [size]="24"
        (click)="monthChange.emit(1)"
      >
        <onyx-icon
          class="right"
          name="arrow-alt-right-outlined"
          [size]="16"
        ></onyx-icon>
      </onyx-icon-button>
    </div>
  } @else {
    @let from = calendarRole() === CalendarRole.FROM;
    <onyx-icon-button
      [class.from]="from"
      variant="transparent"
      color="black"
      [size]="32"
      [icon]="from ? 'arrow-alt-left-outlined' : 'arrow-alt-right-outlined'"
      (click)="monthChange.emit(from ? -1 : 1)"
    ></onyx-icon-button>
  }
</div>
